import { render, staticRenderFns } from "./RewardsShop.vue?vue&type=template&id=6b62b799&scoped=true"
import script from "./RewardsShop.vue?vue&type=script&lang=js"
export * from "./RewardsShop.vue?vue&type=script&lang=js"
import style0 from "./RewardsShop.vue?vue&type=style&index=0&id=6b62b799&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b62b799",
  null
  
)

export default component.exports